/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable react/no-direct-mutation-state */

import React, { Fragment } from 'react';
import moment from 'moment';

import sortIcon from 'assets/images/sort-arrow.png';
import CurrencySign from 'components/price/CurrencySign.component';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import DELAY from 'constants/delay.const';
import IN from 'constants/in';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import { isEnvMobile } from 'utils/env/determine.util';
import delayed from 'utils/functions/delayed.util';
import fixed from 'utils/values/fixed.util';
import parsfixed from 'utils/values/parsfixed.util';

import { STOCK_MANAGER_PDF_TABLE_ID } from 'stocks/consts';

class TableStocksManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editValue: 0,
      editStockId: 0,
      editField: '',
      isInEdit: false,
      price: '',
      displayLoading: false,
      timer: null,
    };
  }

  onChangeInput = (event) => {
    let valueDiff = event.target.value;

    if (valueDiff) {
      this.setState({ editValue: fromAnyToNumber(valueDiff).toFixed(2) });
    } else {
      this.setState({ editValue: '' });
    }

    if (this.isNaN(fromAnyToNumber(valueDiff))) {
      valueDiff = '';
    }
    if (!this.isNaN(fromAnyToNumber(valueDiff)) || valueDiff === '-' || valueDiff === '') {
      if (valueDiff === '') {
        valueDiff = 0;
      }
      this.setState({
        editValue: valueDiff !== '' || 0 ? fromAnyToNumber(valueDiff).toFixed(2) : valueDiff,
      });
    }
  };

  onChangePrice = (price) => {
    if (price) {
      this.setState({ price });
    } else {
      this.setState({ price: '' });
    }
  };

  onDecrement = (value, currentStock) => {
    let setValue = (parseFloat(value) - 1.0).toFixed(2);

    if (this.state.editField === 'quantity') {
      if (this.isNaN(setValue)) {
        this.setState({ editValue: parsfixed('0.00') });
        return;
      }
      if (parseFloat(setValue) < 0) {
        this.setState({ editValue: parsfixed('0.00') });
        return;
      }
      this.setState({ editValue: parsfixed(setValue) });
      return;
    }

    if (this.state.editField === 'min_in_stock') {
      this.onSaveMinInStock(currentStock, false, parseFloat(setValue));
      return;
    }

    if (this.state.editField === 'max_in_stock') {
      this.onSaveMaxInStock(currentStock, false, parseFloat(setValue));
      return;
    }

    if (!this.isNaN(setValue)) {
      setValue = 0;
    }

    if (parseFloat(value) > 0) {
      this.setState({ editValue: parseFloat(setValue) });
    }
  };

  onIncrement = (value, currentStock) => {
    let setValue = (parseFloat(value) + 1.0).toFixed(2);

    if (this.state.editField === 'quantity') {
      if (this.isNaN(setValue)) {
        this.setState({ editValue: parsfixed('0.00') });
        return;
      }
      if (parseFloat(setValue) < 0) {
        this.setState({ editValue: parsfixed('0.00') });
        return;
      }
      this.setState({ editValue: parsfixed(setValue) });
      return;
    }

    if (this.state.editField === 'min_in_stock') {
      this.onSaveMinInStock(currentStock, false, parseFloat(setValue));
      return;
    }

    if (this.state.editField === 'max_in_stock') {
      this.onSaveMaxInStock(currentStock, false, parseFloat(setValue));
      return;
    }

    if (!this.isNaN(setValue)) {
      setValue = 0;
    }

    if (parseFloat(value) > 0) {
      this.setState({ editValue: parseFloat(setValue) });
    }
  };

  onEditProduct = (editStock, fieldToUpdate, clearState, setValue) => {
    const saveItem = editStock;
    if (fieldToUpdate === 'cost_price') {
      saveItem.cost_price = this.state.price !== '' ? parseFloat(this.state.price).toFixed(2) : '';
    }
    if (fieldToUpdate === 'retailPrice') {
      saveItem.price = parseFloat(this.state.price);
    }

    this.props.editStock(this.props.salonId, saveItem, false);

    if (clearState) {
      this.setState({ editStockId: 0, editValue: 0, price: '' });
    }
  };

  onEditQuantity = (editStock, clearState, setValue) => {
    const saveItem = editStock;
    const amountValue = parseFloat(setValue) - editStock.units_in_stock;

    saveItem.units_in_stock = parseFloat(setValue) || parseFloat('0.00');
    saveItem.latest_change.amount = Math.abs(amountValue);
    saveItem.latest_change.type = 'inventory_counting';
    saveItem.latest_change.timestamp = moment();

    this.props.editStock(this.props.salonId, saveItem, false);

    if (clearState) {
      this.setState({ editStockId: 0, editValue: 0, editField: '', isInEdit: false });
    }
  };

  onSaveMinInStock = (editStock, clearState, setValue) => {
    const saveItem = editStock;

    if (!editStock.max_in_stock || editStock.max_in_stock < setValue) {
      saveItem.max_in_stock = setValue;
      this.props.editStockMaxHolding(this.props.salonId, saveItem, setValue);
    }
    saveItem.min_in_stock = setValue;

    delayed(DELAY.attention, () => {
      this.setState({ editValue: parseFloat(setValue) });
      this.props.editStockMinHolding(this.props.salonId, saveItem, setValue);
    });

    if (clearState) {
      this.setState({ editStockId: 0, editValue: 0 });
    }
  };

  onSaveMaxInStock = (editStock, clearState, setValue) => {
    const saveItem = editStock;

    if (!editStock.min_in_stock || editStock.min_in_stock > setValue) {
      this.props.editStockMinHolding(this.props.salonId, saveItem, setValue);
      saveItem.min_in_stock = setValue;
    }

    saveItem.max_in_stock = setValue;

    delayed(DELAY.attention, () => {
      this.setState({ editValue: parseFloat(setValue) });
      this.props.editStockMaxHolding(this.props.salonId, saveItem, setValue);
    });

    if (clearState) {
      this.setState({ editStockId: 0, editValue: 0 });
    }
  };

  onShowCounter = (stockId, currentValue, editField) => {
    this.setState({ editStockId: stockId, editField, editValue: currentValue, isInEdit: true });
  };

  onShowCounterPrice = (stockId, currentValue, editField) => {
    this.setState({ editStockId: stockId, editField, price: currentValue || '', isInEdit: true });
  };

  onToggleChange = (currentStock) => {
    this.props.toggleSelectItem(currentStock, false);
  };

  handleChangeQuantity = (quantity) => {
    if (quantity.match(/^([0-9]{1,5})?(\.\d{0,2})?$/)) {
      this.setState({
        editField: 'quantity',
        isInEdit: true,
        editValue: quantity,
      });
    } else {
      this.setState({ editField: 'quantity', isInEdit: true, editValue: '' });
    }
  };

  handleBlurQuantity = (event, stock) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      // Not triggered when swapping focus between children
      if (parsfixed(stock.units_in_stock) !== parsfixed(this.state.editValue)) {
        this.onEditQuantity(stock, true, this.state.editValue);
      } else {
        this.setState({
          editStockId: 0,
          editValue: 0,
          editField: '',
          isInEdit: false,
        });
      }
    }
  };

  isNaN = (value) => Number.isNaN(Number(value));

  searchFunc = (el) =>
    (el.getName() ? el.getName() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[\u00E9]/g, '')
      .search(this.props.search) !== -1 ||
    (el.getBrand() ? el.getBrand() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+'/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.getFamily() ? el.getFamily() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.getCategory() ? el.getCategory() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.barcode ? el.barcode.toString() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1;

  enableLoading = () => {
    this.setState({ displayLoading: true });
  };

  render() {
    const { t } = this.props;
    const categoryKeys = this.props.sorted.filter(this.searchFunc);

    // this timer, displayLoading and enableLoading() are not using but without them checkboxes not working ???
    // FIXME: shouldn't assign to state directly
    this.state.timer = setTimeout(this.enableLoading, 2000);
    const { displayLoading } = this.state;

    return (
      <div data-bem="TableStocksManager">
        <div className="sort-nav">
          <table className="tbl-fixed-header">
            <tbody>
              <tr>
                <td className="cbox">
                  <div className="cfix relative">
                    <div className="checkbox-box-custom-wrap">
                      <input
                        type="checkbox"
                        className="checkbox-box-custom"
                        id="cbAll"
                        checked={this.props.allItemsSelected}
                        onChange={() => {
                          this.props.toogleCheckAll(false);
                        }}
                      />
                      <label className="checkbox-box-label" htmlFor="cbAll">
                        <div className="checkbox-box-custom-icon">
                          <span className="ic-sml-18px ic_check_white_18" />
                        </div>
                      </label>
                    </div>

                    <TooltipForReceptionist where={IN.stockCb} />
                  </div>
                </td>
                <td className="brand-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('brand');
                    }}
                  >
                    {S.space}
                    <span>{t('stocks.tableHeaders.brand')}</span>
                    <img src={sortIcon} alt="" />
                  </span>
                </td>
                <td className="sub-brand-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('sub-brand');
                    }}
                  >
                    {S.space}
                    <span>{t('stocks.tableHeaders.subBrand')}</span>
                    <img src={sortIcon} alt="" />
                  </span>
                </td>
                <td className="product-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('category');
                    }}
                  >
                    <span>{t('stocks.tableHeaders.category')}</span>
                    <img src={sortIcon} alt="" />
                  </span>
                </td>
                <td className="product-name">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.props.onAddSort('title');
                    }}
                  >
                    <span>{t('stocks.tableHeaders.productName')}</span>
                    <img src={sortIcon} alt="" />
                  </span>
                </td>
                <td style={{ paddingLeft: '0', textAlign: 'center' }} className="cost-price">
                  <span role="button" tabIndex={0}>
                    <span>{t('stocks.tableHeaders.costPrice')}</span>
                  </span>
                </td>
                <td className="retail-price">
                  <span role="button" tabIndex={0}>
                    <span style={{ float: 'none' }}>{t('stocks.tableHeaders.retailPrice')}</span>
                  </span>
                </td>
                <td className="q-in-stock">
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines md"
                    onClick={() => {
                      this.props.onAddSort('quantity');
                    }}
                  >
                    <span>{t('stocks.tableHeaders.stockQuantity')}</span>
                    <img src={sortIcon} alt="" />
                  </span>
                </td>
                <td className="used-sold">
                  <span
                    role="button"
                    tabIndex={0}
                    className="two-lines md"
                    onClick={() => {
                      this.props.onAddSort('used/soldLast30days');
                    }}
                  >
                    <span>{t('stocks.tableHeaders.usedLast30d')}</span>
                    <img src={sortIcon} alt="" />
                  </span>
                </td>
                <td style={{ width: '92px', paddingLeft: '0' }}>
                  <span role="button" tabIndex={0} className="two-lines">
                    <span>{t('stocks.tableHeaders.minHolding')}</span>
                  </span>
                </td>
                <td style={{ width: '92px', paddingLeft: '0' }}>
                  <span role="button" tabIndex={0} className="two-lines">
                    <span>{t('stocks.tableHeaders.maxHolding')}</span>
                  </span>
                </td>
                <td style={{ width: 'auto' }} />
              </tr>
            </tbody>
          </table>
        </div>
        {this.props.isFetching ? (
          <div data-bem="TableStocksManager__spinner" className="spinner-container-in-stocks">
            <div className="load-spinner" />
            <span className="spinner-text">{t('stocks.stockManagerTable.loadingProducts')}</span>
          </div>
        ) : (
          <div data-bem="TableStocksManager__container" className="tbl-container">
            <table className="table-stocks tblManager">
              <tbody>
                {categoryKeys.length > 0 &&
                  categoryKeys.map((catKey) => {
                    const stocks = catKey;

                    const isMobile = isEnvMobile();

                    return (
                      <Fragment key={stocks.id}>
                        {
                          <tr>
                            <td className="cbox ">
                              <div className="cfix relative">
                                <div className="checkbox-box-custom-wrap">
                                  <input
                                    type="checkbox"
                                    className="checkbox-box-custom"
                                    id={`stocks-check-${stocks.id}`}
                                    checked={stocks.selected || ''}
                                    onChange={() => {
                                      this.onToggleChange(stocks);
                                    }}
                                  />
                                  <label className="checkbox-box-label" htmlFor={`stocks-check-${stocks.id}`}>
                                    <div className="checkbox-box-custom-icon">
                                      <span className="ic-sml-18px ic_check_white_18" />
                                    </div>
                                  </label>
                                </div>
                                <TooltipForReceptionist where={IN.stockCb} />
                              </div>
                            </td>
                            <td
                              role="button"
                              tabIndex={0}
                              className="brand-name"
                              onClick={() => {
                                this.props.OnClickRow(stocks);
                              }}
                            >
                              <span>{stocks.brand ? stocks.brand : t('common.unknown')}</span>
                            </td>
                            <td
                              role="button"
                              tabIndex={0}
                              id={`stocks-title-${stocks.id}`}
                              className="sub-brand-name"
                              onClick={() => {
                                this.props.OnClickRow(stocks);
                              }}
                            >
                              {stocks.sub_brand}
                            </td>
                            <td
                              role="button"
                              tabIndex={0}
                              id={`stocks-title-${stocks.id}`}
                              className="product-name"
                              onClick={() => {
                                this.props.OnClickRow(stocks);
                              }}
                            >
                              {stocks.category_name}
                            </td>
                            <td
                              role="button"
                              tabIndex={0}
                              id={`stocks-title-${stocks.id}`}
                              className="product-name"
                              onClick={() => {
                                this.props.OnClickRow(stocks);
                              }}
                            >
                              {stocks.title}
                            </td>
                            <td className="cost-price-body-td relative">
                              <div data-bem="TableStocksMenager__container-cost-price" className="counter-container">
                                <span>
                                  <CurrencySign />
                                </span>
                                &nbsp;
                                <input
                                  type="number"
                                  onBlur={() => {
                                    if (stocks.cost_price !== this.state.price) {
                                      this.onEditProduct(stocks, 'cost_price', true, this.state.editValue);
                                    }
                                  }}
                                  onChange={(e) => {
                                    this.onChangePrice(e.target.value);
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.onShowCounterPrice(stocks.id, stocks.cost_price, 'cost_price');
                                  }}
                                  value={
                                    this.state.isInEdit && this.state.editStockId === stocks.id && this.state.editField === 'cost_price' ? this.state.price : stocks.cost_price ? stocks.cost_price : ''
                                  }
                                  autoComplete="off"
                                />
                                {this.state.editField === 'cost_price' && this.state.editStockId === stocks.id && (
                                  <div className="counter">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.onEditProduct(stocks, 'costPrice', true, this.state.editValue);
                                      }}
                                      className="btn-save"
                                    >
                                      {t('common.buttons.save')}
                                    </button>
                                  </div>
                                )}
                              </div>
                              <TooltipForReceptionist where={IN.counter} />
                            </td>

                            <td className="relative last-td retail-price-body-td ">
                              <div data-bem="TableStocksMenager__container-retail-price" className="counter-container">
                                <span>
                                  <CurrencySign />
                                </span>
                                &nbsp;
                                <input
                                  type="text"
                                  onBlur={() => {
                                    if (stocks.price !== this.state.price) {
                                      this.onEditProduct(stocks, 'retailPrice', true, this.state.editValue);
                                    }
                                  }}
                                  onChange={(e) => {
                                    this.onChangePrice(e.target.value);
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.onShowCounterPrice(stocks.id, stocks.price ? parseFloat(stocks.price).toFixed(2) : '', 'price');
                                  }}
                                  value={
                                    this.state.isInEdit && this.state.editStockId === stocks.id && this.state.editField === 'price'
                                      ? this.state.price
                                      : stocks.price
                                        ? parseFloat(stocks.price).toFixed(2)
                                        : ''
                                  }
                                  autoComplete="off"
                                />
                                {this.state.editField === 'price' && this.state.editStockId === stocks.id && (
                                  <div className="counter">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.onEditProduct(stocks, 'retailPrice', true, this.state.editValue);
                                      }}
                                      className="btn-save"
                                    >
                                      {t('common.buttons.save')}
                                    </button>
                                  </div>
                                )}
                              </div>

                              <TooltipForReceptionist where={IN.counter} />
                            </td>
                            <td className="q-in-stock-body relative">
                              <div data-bem="TableStocksMenager__container-quantity" className="counter-container">
                                {!isMobile ? (
                                  <input
                                    className="desktop-input"
                                    type="text"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.onShowCounter(stocks.id, fixed(stocks.units_in_stock), 'quantity');
                                    }}
                                    value={this.state.isInEdit && this.state.editStockId === stocks.id && this.state.editField === 'quantity' ? this.state.editValue : fixed(stocks.units_in_stock)}
                                    onChange={(e) => this.handleChangeQuantity(e.target.value)}
                                    autoComplete="off"
                                  />
                                ) : (
                                  <input
                                    className="mobile-input" // visible on mobile and disable keyboard
                                    readOnly
                                    type="text"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.onShowCounter(stocks.id, fixed(stocks.units_in_stock), 'quantity');
                                    }}
                                    value={this.state.isInEdit && this.state.editStockId === stocks.id && this.state.editField === 'quantity' ? this.state.editValue : fixed(stocks.units_in_stock)}
                                    onChange={(e) => this.handleChangeQuantity(e.target.value)}
                                    autoComplete="off"
                                  />
                                )}
                                {this.state.editField === 'quantity' && this.state.editStockId === stocks.id && (
                                  <div className="counter" onBlur={(e) => this.handleBlurQuantity(e, stocks)}>
                                    <button onClick={() => this.onDecrement(this.state.isInEdit ? this.state.editValue : stocks.units_in_stock, stocks)} className="decr" />
                                    <button onClick={() => this.onEditQuantity(stocks, true, this.state.editValue)} className="btn-save">
                                      {t('common.buttons.save')}
                                    </button>
                                    <button
                                      onClick={(e) => {
                                        this.onIncrement(this.state.isInEdit ? this.state.editValue : stocks.units_in_stock, stocks);
                                      }}
                                      className="incr"
                                    />
                                  </div>
                                )}
                              </div>

                              <TooltipForReceptionist where={IN.counter} />
                            </td>

                            <td data-bem="TableStocksMenager__container-used-sold" className="used-sold-body-td" style={{ textAlign: 'center' }}>
                              {(parseFloat(stocks.sold_last_30_days) + parseFloat(stocks.used_last_30_days)).toFixed(2)}
                            </td>

                            <td style={{ width: '78px' }} className="relative">
                              <div data-bem="TableStocksMenager__container-min-in-stock" className="counter-container">
                                {!isMobile ? (
                                  <input
                                    className="desktop-input"
                                    type="text"
                                    onChange={this.onChangeInput}
                                    onBlur={() => {
                                      if (stocks.min_in_stock !== this.state.editValue) {
                                        this.onSaveMinInStock(stocks, true, this.state.editValue);
                                      }
                                    }}
                                    placeholder=""
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.onShowCounter(stocks.id, (stocks.min_in_stock && stocks.min_in_stock) || 0, 'min_in_stock');
                                    }}
                                    value={
                                      this.state.isInEdit && this.state.editStockId === stocks.id && this.state.editField === 'min_in_stock'
                                        ? this.state.editValue
                                        : stocks.min_in_stock
                                          ? stocks.min_in_stock
                                          : ''
                                    }
                                    autoComplete="off"
                                    readOnly
                                  />
                                ) : (
                                  <input
                                    className="mobile-input" // visible on mobile and disable keyboard
                                    readOnly
                                    type="text"
                                    onChange={this.onChangeInput}
                                    onBlur={() => {
                                      if (stocks.min_in_stock !== this.state.editValue) {
                                        this.onSaveMinInStock(stocks, true, this.state.editValue);
                                      }
                                    }}
                                    placeholder=""
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.onShowCounter(stocks.id, stocks.min_in_stock, 'min_in_stock');
                                    }}
                                    value={
                                      this.state.isInEdit && this.state.editStockId === stocks.id && this.state.editField === 'min_in_stock'
                                        ? this.state.editValue
                                        : stocks.min_in_stock
                                          ? stocks.min_in_stock
                                          : ''
                                    }
                                    autoComplete="off"
                                  />
                                )}
                                {this.state.editField === 'min_in_stock' && this.state.editStockId === stocks.id && (
                                  <div className="counter">
                                    <button onClick={() => this.onDecrement(this.state.editValue ? this.state.editValue : stocks.min_in_stock, stocks)} className="decr" />
                                    <button onClick={() => this.onSaveMinInStock(stocks, true, this.state.editValue)} className="btn-save">
                                      {t('common.buttons.save')}
                                    </button>
                                    <button onClick={() => this.onIncrement(this.state.editValue ? this.state.editValue : stocks.min_in_stock, stocks)} className="incr" />
                                  </div>
                                )}
                              </div>

                              <TooltipForReceptionist where={IN.counter} />
                            </td>
                            <td style={{ width: '78px' }} className="relative">
                              <div data-bem="TableStocksMenager__container-max-in-stock" className="counter-container">
                                {isMobile ? (
                                  <input
                                    className="desktop-input"
                                    type="text"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.onShowCounter(stocks.id, stocks.max_in_stock, 'max_in_stock');
                                    }}
                                    onBlur={() => {
                                      if (stocks.max_in_stock !== this.state.editValue) {
                                        this.onSaveMaxInStock(stocks, true, this.state.editValue);
                                      }
                                    }}
                                    value={
                                      this.state.isInEdit && this.state.editStockId === stocks.id && this.state.editField === 'max_in_stock'
                                        ? this.state.editValue
                                        : stocks.max_in_stock
                                          ? stocks.max_in_stock
                                          : ''
                                    }
                                    onChange={this.onChangeInput}
                                    autoComplete="off"
                                  />
                                ) : (
                                  <input
                                    className="mobile-input" // visible on mobile and disable keyboard
                                    readOnly
                                    type="text"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.onShowCounter(stocks.id, stocks.max_in_stock, 'max_in_stock');
                                    }}
                                    onBlur={() => {
                                      if (stocks.max_in_stock !== this.state.editValue) {
                                        this.onSaveMaxInStock(stocks, true, this.state.editValue);
                                      }
                                    }}
                                    value={
                                      this.state.isInEdit && this.state.editStockId === stocks.id && this.state.editField === 'max_in_stock'
                                        ? this.state.editValue
                                        : stocks.max_in_stock
                                          ? stocks.max_in_stock
                                          : ''
                                    }
                                    onChange={this.onChangeInput}
                                    autoComplete="off"
                                  />
                                )}
                                {this.state.editField === 'max_in_stock' && this.state.editStockId === stocks.id && (
                                  <div className="counter">
                                    <button onClick={() => this.onDecrement(this.state.editValue ? this.state.editValue : stocks.max_in_stock, stocks)} className="decr" />
                                    <button onClick={() => this.onSaveMaxInStock(stocks, true, this.state.editValue)} className="btn-save">
                                      {t('common.buttons.save')}
                                    </button>
                                    <button onClick={() => this.onIncrement(this.state.editValue ? this.state.editValue : stocks.max_in_stock, stocks)} className="incr" />
                                  </div>
                                )}
                              </div>

                              <TooltipForReceptionist where={IN.counter} />
                            </td>
                            <td style={{ width: 'auto' }} />
                          </tr>
                        }
                      </Fragment>
                    );
                  })}
                {!this.props.isFetching && (
                  <>
                    {categoryKeys.length === 0 && (
                      <tr>
                        <td style={{ textAlign: 'center' }}>{t('stocks.stockManagerTable.noProductsMsg')}</td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Hacky workaround to make the pdf downloadable from each tab of manager layout */}
        {/* PDF start */}
        {/* The id={STOCK_MANAGER_PDF_TABLE_ID} is used to generate the downloadable PDF file */}
        <table id={STOCK_MANAGER_PDF_TABLE_ID} style={{ display: 'none' }}>
          <thead>
            <tr>
              <th>{t('stocks.tableHeaders.brand')}</th>
              <th>{t('stocks.tableHeaders.subBrand')}</th>
              <th>{t('stocks.tableHeaders.productName')}</th>
              <th>{t('stocks.tableHeaders.costPrice')}</th>
              <th>{t('stocks.tableHeaders.retailPrice')}</th>
              <th>{t('stocks.tableHeaders.stockQuantity')}</th>
              <th>{t('stocks.tableHeaders.usedLast30d')}</th>
              <th>{t('stocks.tableHeaders.minHolding')}</th>
              <th>{t('stocks.tableHeaders.maxHolding')}</th>
            </tr>
          </thead>
          <tbody>
            {categoryKeys.length > 0 &&
              categoryKeys.map((stocks) => (
                <tr key={stocks.id}>
                  <td>{stocks.brand ? stocks.brand : t('common.unknown')}</td>
                  <td>{stocks.sub_brand ? stocks.sub_brand : S.minus}</td>
                  <td>{stocks.title}</td>
                  <td>
                    {stocks.cost_price && <CurrencySign />}
                    {stocks.cost_price ? stocks.cost_price : S.minus}
                  </td>
                  <td>
                    {stocks.price && <CurrencySign />}
                    {stocks.price ? parseFloat(stocks.price).toFixed(2) : S.minus}
                  </td>
                  <td>{fixed(stocks.units_in_stock)}</td>
                  <td>{(parseFloat(stocks.sold_last_30_days) + parseFloat(stocks.used_last_30_days)).toFixed(2)}</td>
                  <td>{stocks.min_in_stock ? stocks.min_in_stock : S.minus}</td>
                  <td>{stocks.max_in_stock ? stocks.max_in_stock : S.minus}</td>
                </tr>
              ))}
            {categoryKeys.length === 0 && (
              <tr>
                <td style={{ textAlign: 'center' }}>{t('stocks.tableHeaders.noProductsMsg')}</td>
              </tr>
            )}
          </tbody>
        </table>
        {/* PDF end */}
      </div>
    );
  }
}

const TableStocksManagerHoc = withTranslation()(TableStocksManager);

export default TableStocksManagerHoc;
